import {
  ArrowSmLeftIcon,
  ArrowSmRightIcon,
  InformationCircleIcon,
  PencilAltIcon,
  TrashIcon as HeroTrashIcon,
  XIcon as HeroXIcon
} from '@heroicons/react/outline'
import {
  CheckIcon as HeroCheckIcon,
  ChevronDownIcon as HeroChevronDownIcon,
  ChevronUpIcon as HeroChevronUpIcon,
  HandIcon
} from '@heroicons/react/solid'

const defaultDisplay = 'inline-block'
const defaultIconClass = `h-5 ${defaultDisplay} flex-none` as const

export const ArrowLeftIcon = () => <ArrowSmLeftIcon className={defaultIconClass} />

export const ArrowRightIcon = () => <ArrowSmRightIcon className={defaultIconClass} />

export const CheckIcon = () => <HeroCheckIcon className={`${defaultIconClass} text-green-400`} />

export const ChevronUpIcon = () => <HeroChevronUpIcon className={`${defaultDisplay} h-4`} />

export const ChevronDownIcon = () => <HeroChevronDownIcon className={`${defaultDisplay} h-4`} />

export const InfoIcon = () => <InformationCircleIcon className={defaultIconClass} />

export const MobileMapManipulationIcon = () => <HandIcon className="h-7" />

export const XIcon = ({ large = false }) => (
  <HeroXIcon className={`${defaultIconClass} ${large ? 'h-7' : ''} `} />
)

export const SelectorIcon = ({ disabled = false }) => (
  <HeroChevronDownIcon
    className={`h-5 flex-none ${disabled ? 'text-gray-400' : 'text-green-400'} `}
  />
)

export const EditIcon = () => (
  <PencilAltIcon className={`${defaultDisplay} h - 4 text - green - 300`} />
)

export const TrashIcon = ({ color = 'text-green-400' }) => (
  <HeroTrashIcon className={`${defaultDisplay} h - 4 ${color} `} />
)
